// Reducer for the shortcutById, the sub-state under shortcuts.

import * as ActionTypes from '../constants/action_types'
import { DefaultState } from './DefaultState'
import * as ReducerUtils from './utils'

export const DefaultTopicsListState = {
  ...DefaultState
}

export const topicsList = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultTopicsListState,
  actionRequest: ActionTypes.REQUEST_TOPICS,
  actionFailure: ActionTypes.REQUEST_TOPICS_FAILURE,
  actionReceive: ActionTypes.RECEIVE_TOPICS,
  actionInvalidate: ActionTypes.INVALIDATE_TOPICS
})

export const DefaultSearchListState = {
  ...DefaultState
}

export const searchList = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultSearchListState,
  actionRequest: ActionTypes.SEARCH_RESULT_REQUEST,
  actionFailure: ActionTypes.SEARCH_RESULT_FAILURE,
  actionReceive: ActionTypes.SEARCH_RESULT_SUCCESS
})

export const DefaultTopicsCountState = {
  ...DefaultState
}

export const topicsCount = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultTopicsCountState,
  actionRequest: ActionTypes.REQUEST_TOPICS_COUNT,
  actionFailure: ActionTypes.REQUEST_TOPICS_COUNT_FAILURE,
  actionReceive: ActionTypes.RECEIVE_TOPICS_COUNT,
  actionInvalidate: ActionTypes.INVALIDATE_TOPICS_COUNT
})